module.exports = __webpack_public_path__ + "static/linkedinLit-8820ca402391cd74a0865baf6eedf5db.png";